var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D868C"
    },
    d: "M393.672,106.475c-2.191,0-4.382-0.836-6.054-2.507l-64.016-64.017 c-3.343-3.344-3.343-8.764,0-12.107c3.345-3.343,8.765-3.341,12.107,0l64.016,64.017c3.343,3.344,3.343,8.764,0,12.107 C398.054,105.639,395.863,106.475,393.672,106.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D868C"
    },
    d: "M478.102,190.904c-2.191,0-4.382-0.835-6.054-2.508l-64.015-64.017 c-3.343-3.343-3.343-8.763,0.001-12.106c3.342-3.342,8.763-3.343,12.107,0.001l64.015,64.017c3.343,3.343,3.343,8.763-0.001,12.107 C482.484,190.068,480.292,190.904,478.102,190.904z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M399.726,91.86l-18.461-18.462c-5.986,1.256-11.776,3.648-17.03,7.186 l23.383,23.383c1.672,1.671,3.863,2.507,6.054,2.507c2.19,0,4.382-0.836,6.054-2.507C403.069,100.624,403.069,95.204,399.726,91.86z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M420.141,112.274c-3.344-3.344-8.765-3.343-12.107-0.001 c-3.344,3.344-3.344,8.764-0.001,12.106l23.383,23.384c3.538-5.253,5.931-11.044,7.185-17.029L420.141,112.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE00"
    },
    d: "M138.418,501.931c13.426,13.425,35.194,13.425,48.622,0c13.425-13.425,13.425-35.194,0-48.619 l-128.35-128.35c-13.426-13.426-35.195-13.426-48.622,0c-13.424,13.426-13.423,35.193,0.001,48.619L138.418,501.931z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7D868C"
    },
    cx: 391.24,
    cy: 120.76,
    r: 37.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M396.395,115.607c-9.875-9.875-19.352-17.761-28.511-23.715 c-1.001,0.812-1.971,1.681-2.901,2.612c-14.502,14.503-14.502,38.014,0,52.514c14.499,14.503,38.014,14.503,52.515,0 c0.937-0.937,1.813-1.915,2.63-2.923C414.192,134.982,406.32,125.533,396.395,115.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M69.946,336.219c-16.447,19.567-28.938,34.142-33.379,38.584 c-4.364,4.362-8.038,9.156-11.028,14.246l97.412,97.414c5.09-2.99,9.883-6.665,14.248-11.028 c4.442-4.445,19.015-16.932,38.582-33.382L69.946,336.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M388.324,123.678c-31.688-31.688-65.557-49.195-97.242-17.507 c-36.951,36.953-217.814,260.602-240.18,282.966c-19.871,19.873-19.873,52.093,0,71.962c19.872,19.875,52.091,19.871,71.962,0 c22.366-22.364,246.014-203.226,282.966-240.179C437.515,189.233,420.008,155.363,388.324,123.678z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7D868C"
    },
    cx: 217.666,
    cy: 294.334,
    r: 37.13
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M279.476,118.569c-26.167,29.021-76.481,89.439-123.477,146.015 l91.416,91.417c56.578-46.996,116.996-97.307,146.015-123.478L279.476,118.569z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE00"
    },
    d: "M388.76,465.425c28.194,28.193,73.901,28.19,102.096-0.003 c28.192-28.19,28.193-73.899-0.001-102.093L148.672,21.145c-28.194-28.194-73.901-28.194-102.094,0 c-28.194,28.193-28.195,73.903-0.002,102.093L388.76,465.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE00"
    },
    d: "M78.617,441.946c-2.19,0-4.382-0.837-6.053-2.507c-3.344-3.343-3.344-8.764-0.001-12.106 l52.509-52.511c3.344-3.344,8.765-3.343,12.106-0.001c3.344,3.343,3.344,8.764,0.001,12.106L84.67,439.438 C82.999,441.11,80.807,441.946,78.617,441.946z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171.684,
    y: 82.6,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 198.2412 391.7014)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 17.121,
    height: 144.386
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.983,
    y: 23.923,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 139.524 250.0243)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 17.121,
    height: 144.386
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.636,
    y: 259.578,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 375.1749 818.9456)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 17.121,
    height: 144.386
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.319,
    y: 318.259,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 433.8593 960.6151)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 17.121,
    height: 144.386
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.b7066feeee7b08d3a08c5efb20c6e76e.svg";
export { ForwardRef as ReactComponent };